export const CONSTANTS_TIME__client = {
  ANIMATION_DURATION_SCROLL_TO_USER_TASK_HISTORY_NODE: 600,
  /*
   * DEBOUNCE
   */

  DEBOUNCE_GRID2D_CHANGE_CELL_SIZE_BY_SCROLL_REMOTE: 1000, //in ms

  // in ms
  DEBOUNCE_IMAGE_CANVAS_SEND_CROPPING_UPDATE: 2000,

  DEBOUNCE_IMAGE_CANVAS_SLIDER_STRENGTH: 10, //in ms

  //in ms
  DEBOUNCE_GRID2D_LOAD_CELLS: 100,

  //in ms
  DEBOUNCE_GENERATION_GRID2D_AND_LIST: 100,

  //in ms
  DEBOUNCE_LOAD_DIFFUSION_MODELS: 200,

  //in ms
  DEBOUNCE_LOAD_DIFFUSION_MODELS_QUERY: 500,

  /*
   * INTERVAL
   */

  //in ms
  INTERVAL_UPDATE_DIFFUSION_MODELS_CIVITAI_CONVERTING: 30 * 1000,

  //in ms
  INTERVAL_FPS: 1000,

  //in ms
  INTERVAL_RAM: 2 * 1000,

  //in ms
  INTERVAL_PING: 10 * 1000,

  INTERVAL_ANIMATION_DELAY_HINT_SHORTCUT_KEY_CLICK: 3 * 1000, //in ms

  INTERVAL_ANIMATE_BORDER_FOR_DRAW: 100, //in ms

  /*
   * TIMEOUT
   */

  // in ms
  TIMEOUT_DURATION_ANIMATION_NOTIFIER_BLINK: 1000,

  //in ms
  TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER: 300,

  //in ms
  TIMEOUT_DURATION_ANIMATION_CREDITS_BALANCE: 500,

  //in ms
  TIMEOUT_DURATION_ANIMATION_BUTTON_NAVIGATION_GENERATION: 500,

  //in ms
  TIMEOUT_DELAY_SPLASH_HIDE: 500,

  TIMEOUT_ANIMATION_DURARION_HINT_SHORTCUT_KEY_CLICK: 500, //in ms

  //in ms
  TIMEOUT_ANIMATION_SLIDER_TEMPORARY_MARKS_DELAY: 500,

  TIMEOUT_ANIMATION_DELAY_HINT_SHORTCUT_LIST_ITEM: 250, //in ms

  TIMEOUT_ANIMATION_HINT_SHORTCUT_HIDE: 200, //in ms

  TIMEOUT_DURATION_GENERATION_NEXT_INFO_HIDE: 3000, //in ms

  /*
   * THROTTLE
   */

  THROTTLE_GRID2D_FLOAT_UPDATE_POSSIBLE_ON_SCREEN_CELLS_INDICES: 10, // in ms

  THROTTLE_GRID2D_CHANGE_CELL_SIZE_BY_SCROLL_LOCAL: 50, //in ms

  THROTTLE_TRANSLATE_TOKENS_FROM_ENGLISH: 100 * 1000, //in ms

  THROTTLE_COLLECTION_CREATE: 1000, //in ms
  THROTTLE_USER_TASK_CREATE: 1000, //in ms

  THROTTLE_IMAGE_LOADING: 500, //in ms

  /*
   * TOASTS
   */
  //is ms
  TOAST_DURATION_WORKSPACE_CHILD_ENTITY_DELETE: 10 * 1000,

  //is ms
  TOAST_DURATION_DELETE_ALL_TOKENS: 10 * 1000,

  //in ms
  TOAST_DURATION_ERROR: 10 * 1000,

  SECONDS_3: 3 * 1000,

  MS_300: 300,
};
